import { useEffect } from 'react';
import { navigate } from "@reach/router"

const FleetManagementPage = () => {
  useEffect(() => {
    navigate('/solutions/use-cases/equipment-maintenance/');
  }, []);
  return null;
};

export default FleetManagementPage;